export const activityConstants = {
    FETCH_REQUEST: 'ACTIVITY_FETCH_REQUEST',
    FETCH_SUCCESS: 'ACTIVITY_FETCH_SUCCESS',
    FETCH_FAILURE: 'ACTIVITY_FETCH_FAILURE',
};
